import React from "react";
import StaffRequirementInput from "./StaffRequirementInput";

const StaffRequirementRow = ({ label, values, onChange, isDisabled }) => {
    const weekValues = values.slice(0, 7);

    return (
        <tr>
            <td className="px-4 py-3 border bg-gray-50 font-medium text-sm text-gray-700">
                {label}
            </td>
            {weekValues.map((value, index) => (
                <td key={index} className="border">
                    <StaffRequirementInput
                        value={value}
                        onChange={(value) => onChange(index, value)}
                        isDisabled={isDisabled}

                    />
                </td>
            ))}
        </tr>
    );
};

export default StaffRequirementRow;